import { atom } from 'recoil';

const showDocs = atom({
  key: 'showDocs',
  default: false,
});
export default showDocs;
